var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnauthQrCode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9133_143999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72 0H0V72H72V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2025 4.83572C22.7496 4.83572 23.1931 4.39221 23.1931 3.84511C23.1931 3.298 22.7496 2.85449 22.2025 2.85449C21.6554 2.85449 21.2119 3.298 21.2119 3.84511C21.2119 4.39221 21.6554 4.83572 22.2025 4.83572Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7846 4.83572C27.3317 4.83572 27.7752 4.39221 27.7752 3.84511C27.7752 3.298 27.3317 2.85449 26.7846 2.85449C26.2375 2.85449 25.7939 3.298 25.7939 3.84511C25.7939 4.39221 26.2375 4.83572 26.7846 4.83572Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6566 4.83572C34.2037 4.83572 34.6472 4.39221 34.6472 3.84511C34.6472 3.298 34.2037 2.85449 33.6566 2.85449C33.1095 2.85449 32.666 3.298 32.666 3.84511C32.666 4.39221 33.1095 4.83572 33.6566 4.83572Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5287 4.83572C41.0758 4.83572 41.5193 4.39221 41.5193 3.84511C41.5193 3.298 41.0758 2.85449 40.5287 2.85449C39.9816 2.85449 39.5381 3.298 39.5381 3.84511C39.5381 4.39221 39.9816 4.83572 40.5287 4.83572Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.142 2.82392C44.5848 2.82392 44.1514 3.28827 44.1514 3.81454C44.1514 4.37176 44.6157 4.80515 45.142 4.80515H46.2874V2.79297H45.142V2.82392Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4325 4.83572C47.9897 4.83572 48.4231 4.37137 48.4231 3.84511C48.4231 3.28789 47.9588 2.85449 47.4325 2.85449H46.2871V4.83572H47.4325Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2025 7.12673C22.7496 7.12673 23.1931 6.68322 23.1931 6.13612C23.1931 5.58902 22.7496 5.14551 22.2025 5.14551C21.6554 5.14551 21.2119 5.58902 21.2119 6.13612C21.2119 6.68322 21.6554 7.12673 22.2025 7.12673Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0746 7.12673C29.6217 7.12673 30.0652 6.68322 30.0652 6.13612C30.0652 5.58902 29.6217 5.14551 29.0746 5.14551C28.5275 5.14551 28.084 5.58902 28.084 6.13612C28.084 6.68322 28.5275 7.12673 29.0746 7.12673Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9476 7.12673C36.4947 7.12673 36.9383 6.68322 36.9383 6.13612C36.9383 5.58902 36.4947 5.14551 35.9476 5.14551C35.4005 5.14551 34.957 5.58902 34.957 6.13612C34.957 6.68322 35.4005 7.12673 35.9476 7.12673Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8197 7.12673C43.3668 7.12673 43.8103 6.68322 43.8103 6.13612C43.8103 5.58902 43.3668 5.14551 42.8197 5.14551C42.2726 5.14551 41.8291 5.58902 41.8291 6.13612C41.8291 6.68322 42.2726 7.12673 42.8197 7.12673Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.432 7.12673C47.9791 7.12673 48.4226 6.68322 48.4226 6.13612C48.4226 5.58902 47.9791 5.14551 47.432 5.14551C46.8849 5.14551 46.4414 5.58902 46.4414 6.13612C46.4414 6.68322 46.8849 7.12673 47.432 7.12673Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2025 7.40547C21.6453 7.40547 21.2119 7.86982 21.2119 8.39608C21.2119 8.9533 21.6763 9.38669 22.2025 9.38669H23.3479V7.37451H22.2025V7.40547Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4931 9.41775C25.0503 9.41775 25.4837 8.9534 25.4837 8.42714C25.4837 7.86992 25.0193 7.43652 24.4931 7.43652H23.3477V9.44871H24.4931V9.41775Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0746 9.41775C29.6217 9.41775 30.0652 8.97424 30.0652 8.42714C30.0652 7.88003 29.6217 7.43652 29.0746 7.43652C28.5275 7.43652 28.084 7.88003 28.084 8.42714C28.084 8.97424 28.5275 9.41775 29.0746 9.41775Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6566 9.41775C34.2037 9.41775 34.6472 8.97424 34.6472 8.42714C34.6472 7.88003 34.2037 7.43652 33.6566 7.43652C33.1095 7.43652 32.666 7.88003 32.666 8.42714C32.666 8.97424 33.1095 9.41775 33.6566 9.41775Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5287 9.41775C41.0758 9.41775 41.5193 8.97424 41.5193 8.42714C41.5193 7.88003 41.0758 7.43652 40.5287 7.43652C39.9816 7.43652 39.5381 7.88003 39.5381 8.42714C39.5381 8.97424 39.9816 9.41775 40.5287 9.41775Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.432 7.40547C46.8748 7.40547 46.4414 7.86982 46.4414 8.39608C46.4414 8.9533 46.9058 9.38669 47.432 9.38669H48.5774V7.37451H47.432V7.40547Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7235 9.41775C50.2807 9.41775 50.7141 8.9534 50.7141 8.42714C50.7141 7.86992 50.2498 7.43652 49.7235 7.43652H48.5781V9.44871H49.7235V9.41775Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7846 11.7083C27.3317 11.7083 27.7752 11.2648 27.7752 10.7177C27.7752 10.1706 27.3317 9.72705 26.7846 9.72705C26.2375 9.72705 25.7939 10.1706 25.7939 10.7177C25.7939 11.2648 26.2375 11.7083 26.7846 11.7083Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6566 9.696C33.0994 9.696 32.666 10.1603 32.666 10.6866C32.666 11.2438 33.1304 11.6772 33.6566 11.6772H34.802V9.66504H33.6566V9.696Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0925 9.69629H34.8018V11.7085H37.0925V9.69629Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2382 11.7083C38.7954 11.7083 39.2288 11.2439 39.2288 10.7177C39.2288 10.1604 38.7644 9.72705 38.2382 9.72705H37.0928V11.7392H38.2382V11.7083Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8197 9.696C42.2625 9.696 41.8291 10.1603 41.8291 10.6866C41.8291 11.2438 42.2935 11.6772 42.8197 11.6772H43.9651V9.66504H42.8197V9.696Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1415 11.7083C45.6987 11.7083 46.1321 11.2439 46.1321 10.7177C46.1321 10.1604 45.6678 9.72705 45.1415 9.72705H43.9961V11.7392H45.1415V11.7083Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.723 11.7083C50.2701 11.7083 50.7136 11.2648 50.7136 10.7177C50.7136 10.1706 50.2701 9.72705 49.723 9.72705C49.1759 9.72705 48.7324 10.1706 48.7324 10.7177C48.7324 11.2648 49.1759 11.7083 49.723 11.7083Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4935 12.0178C23.9363 12.0178 23.5029 12.4821 23.5029 13.0084C23.5029 13.5656 23.9673 13.999 24.4935 13.999H25.6389V11.9868H24.4935V12.0178Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7841 13.9993C27.3413 13.9993 27.7747 13.5349 27.7747 13.0087C27.7747 12.4515 27.3103 12.0181 26.7841 12.0181H25.6387V14.0302H26.7841V13.9993Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3656 12.0178C30.8084 12.0178 30.375 12.4821 30.375 13.0084C30.375 13.5656 30.8393 13.999 31.3656 13.999H32.511V11.9868H31.3656V12.0178Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6571 13.9993C34.2143 13.9993 34.6477 13.5349 34.6477 13.0087C34.6477 12.4515 34.1834 12.0181 33.6571 12.0181H32.5117V14.0302H33.6571V13.9993Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.142 13.9993C45.6891 13.9993 46.1326 13.5558 46.1326 13.0087C46.1326 12.4616 45.6891 12.0181 45.142 12.0181C44.5949 12.0181 44.1514 12.4616 44.1514 13.0087C44.1514 13.5558 44.5949 13.9993 45.142 13.9993Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2025 16.2898C22.7496 16.2898 23.1931 15.8463 23.1931 15.2992C23.1931 14.7521 22.7496 14.3086 22.2025 14.3086C21.6554 14.3086 21.2119 14.7521 21.2119 15.2992C21.2119 15.8463 21.6554 16.2898 22.2025 16.2898Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3656 16.2898C31.9127 16.2898 32.3562 15.8463 32.3562 15.2992C32.3562 14.7521 31.9127 14.3086 31.3656 14.3086C30.8185 14.3086 30.375 14.7521 30.375 15.2992C30.375 15.8463 30.8185 16.2898 31.3656 16.2898Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9476 14.3088C35.3904 14.3088 34.957 14.7731 34.957 15.2994C34.957 15.8257 35.4214 16.29 35.9476 16.29H37.093V14.2778H35.9476V14.3088Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2382 16.2898C38.7954 16.2898 39.2288 15.8255 39.2288 15.2992C39.2288 14.7729 38.7644 14.3086 38.2382 14.3086H37.0928V16.2898H38.2382Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.142 16.2898C45.6891 16.2898 46.1326 15.8463 46.1326 15.2992C46.1326 14.7521 45.6891 14.3086 45.142 14.3086C44.5949 14.3086 44.1514 14.7521 44.1514 15.2992C44.1514 15.8463 44.5949 16.2898 45.142 16.2898Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.723 16.2898C50.2701 16.2898 50.7136 15.8463 50.7136 15.2992C50.7136 14.7521 50.2701 14.3086 49.723 14.3086C49.1759 14.3086 48.7324 14.7521 48.7324 15.2992C48.7324 15.8463 49.1759 16.2898 49.723 16.2898Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2025 18.5808C22.7496 18.5808 23.1931 18.1373 23.1931 17.5902C23.1931 17.0431 22.7496 16.5996 22.2025 16.5996C21.6554 16.5996 21.2119 17.0431 21.2119 17.5902C21.2119 18.1373 21.6554 18.5808 22.2025 18.5808Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7846 18.5808C27.3317 18.5808 27.7752 18.1373 27.7752 17.5902C27.7752 17.0431 27.3317 16.5996 26.7846 16.5996C26.2375 16.5996 25.7939 17.0431 25.7939 17.5902C25.7939 18.1373 26.2375 18.5808 26.7846 18.5808Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3656 18.5808C31.9127 18.5808 32.3562 18.1373 32.3562 17.5902C32.3562 17.0431 31.9127 16.5996 31.3656 16.5996C30.8185 16.5996 30.375 17.0431 30.375 17.5902C30.375 18.1373 30.8185 18.5808 31.3656 18.5808Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9476 18.5808C36.4947 18.5808 36.9383 18.1373 36.9383 17.5902C36.9383 17.0431 36.4947 16.5996 35.9476 16.5996C35.4005 16.5996 34.957 17.0431 34.957 17.5902C34.957 18.1373 35.4005 18.5808 35.9476 18.5808Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5287 18.5808C41.0758 18.5808 41.5193 18.1373 41.5193 17.5902C41.5193 17.0431 41.0758 16.5996 40.5287 16.5996C39.9816 16.5996 39.5381 17.0431 39.5381 17.5902C39.5381 18.1373 39.9816 18.5808 40.5287 18.5808Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.142 18.5808C45.6891 18.5808 46.1326 18.1373 46.1326 17.5902C46.1326 17.0431 45.6891 16.5996 45.142 16.5996C44.5949 16.5996 44.1514 17.0431 44.1514 17.5902C44.1514 18.1373 44.5949 18.5808 45.142 18.5808Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.723 18.5808C50.2701 18.5808 50.7136 18.1373 50.7136 17.5902C50.7136 17.0431 50.2701 16.5996 49.723 16.5996C49.1759 16.5996 48.7324 17.0431 48.7324 17.5902C48.7324 18.1373 49.1759 18.5808 49.723 18.5808Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2025 18.8903C21.6453 18.8903 21.2119 19.3547 21.2119 19.8809C21.2119 20.4382 21.6763 20.8716 22.2025 20.8716H23.3479V18.8594H22.2025V18.8903Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6384 18.8901H23.3477V20.9023H25.6384V18.8901Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7841 20.8714C27.3413 20.8714 27.7747 20.407 27.7747 19.8807C27.7747 19.3235 27.3103 18.8901 26.7841 18.8901H25.6387V20.9023H26.7841V20.8714Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6566 20.8714C34.2037 20.8714 34.6472 20.4278 34.6472 19.8807C34.6472 19.3336 34.2037 18.8901 33.6566 18.8901C33.1095 18.8901 32.666 19.3336 32.666 19.8807C32.666 20.4278 33.1095 20.8714 33.6566 20.8714Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2387 18.8903C37.6814 18.8903 37.248 19.3547 37.248 19.8809C37.248 20.4382 37.7124 20.8716 38.2387 20.8716H39.3841V18.8594H38.2387V18.8903Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5292 20.8714C41.0864 20.8714 41.5198 20.407 41.5198 19.8807C41.5198 19.3235 41.0554 18.8901 40.5292 18.8901H39.3838V20.9023H40.5292V20.8714Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.142 18.8903C44.5848 18.8903 44.1514 19.3547 44.1514 19.8809C44.1514 20.4382 44.6157 20.8716 45.142 20.8716H46.2874V18.8594H45.142V18.8903Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5779 18.8901H46.2871V20.9023H48.5779V18.8901Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7235 20.8714C50.2807 20.8714 50.7141 20.407 50.7141 19.8807C50.7141 19.3235 50.2498 18.8901 49.7235 18.8901H48.5781V20.9023H49.7235V20.8714Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.45839 21.1813C7.90117 21.1813 7.46777 21.6457 7.46777 22.172C7.46777 22.6982 7.93212 23.1626 8.45839 23.1626H9.60378V21.1504H8.45839V21.1813Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8943 21.1812H9.60352V23.1933H11.8943V21.1812Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0399 23.1624C13.5971 23.1624 14.0305 22.698 14.0305 22.1718C14.0305 21.6455 13.5662 21.1812 13.0399 21.1812H11.8945V23.1933H13.0399V23.1624Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6215 23.1624C18.1686 23.1624 18.6121 22.7189 18.6121 22.1718C18.6121 21.6247 18.1686 21.1812 17.6215 21.1812C17.0744 21.1812 16.6309 21.6247 16.6309 22.1718C16.6309 22.7189 17.0744 23.1624 17.6215 23.1624Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2025 23.1624C22.7496 23.1624 23.1931 22.7189 23.1931 22.1718C23.1931 21.6247 22.7496 21.1812 22.2025 21.1812C21.6554 21.1812 21.2119 21.6247 21.2119 22.1718C21.2119 22.7189 21.6554 23.1624 22.2025 23.1624Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7846 21.1813C26.2273 21.1813 25.7939 21.6457 25.7939 22.172C25.7939 22.6982 26.2583 23.1626 26.7846 23.1626H27.93V21.1504H26.7846V21.1813Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2205 21.1812H27.9297V23.1933H30.2205V21.1812Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3661 23.1624C31.9233 23.1624 32.3567 22.698 32.3567 22.1718C32.3567 21.6455 31.8924 21.1812 31.3661 21.1812H30.2207V23.1933H31.3661V23.1624Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5287 23.1624C41.0758 23.1624 41.5193 22.7189 41.5193 22.1718C41.5193 21.6247 41.0758 21.1812 40.5287 21.1812C39.9816 21.1812 39.5381 21.6247 39.5381 22.1718C39.5381 22.7189 39.9816 23.1624 40.5287 23.1624Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.142 23.1624C45.6891 23.1624 46.1326 22.7189 46.1326 22.1718C46.1326 21.6247 45.6891 21.1812 45.142 21.1812C44.5949 21.1812 44.1514 21.6247 44.1514 22.1718C44.1514 22.7189 44.5949 23.1624 45.142 23.1624Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.723 21.1813C49.1658 21.1813 48.7324 21.6457 48.7324 22.172C48.7324 22.6982 49.1968 23.1626 49.723 23.1626H50.8684V21.1504H49.723V21.1813Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.159 21.1812H50.8682V23.1933H53.159V21.1812Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.45 21.1812H53.1592V23.1933H55.45V21.1812Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5956 23.1624C57.1528 23.1624 57.5862 22.698 57.5862 22.1718C57.5862 21.6455 57.1219 21.1812 56.5956 21.1812H55.4502V23.1933H56.5956V23.1624Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4682 21.1813C62.9109 21.1813 62.4775 21.6457 62.4775 22.172C62.4775 22.6982 62.9419 23.1626 63.4682 23.1626H64.6135V21.1504H63.4682V21.1813Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9041 21.1812H64.6133V23.1933H66.9041V21.1812Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0497 23.1624C68.6069 23.1624 69.0403 22.698 69.0403 22.1718C69.0403 21.6455 68.576 21.1812 68.0497 21.1812H66.9043V23.1933H68.0497V23.1624Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.87636 25.4529C4.42346 25.4529 4.86697 25.0094 4.86697 24.4623C4.86697 23.9152 4.42346 23.4717 3.87636 23.4717C3.32925 23.4717 2.88574 23.9152 2.88574 24.4623C2.88574 25.0094 3.32925 25.4529 3.87636 25.4529Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.45839 23.4719C7.90117 23.4719 7.46777 23.9362 7.46777 24.4625C7.46777 25.0197 7.93212 25.4531 8.45839 25.4531H9.60378V23.4409H8.45839V23.4719Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8943 23.4717H9.60352V25.4839H11.8943V23.4717Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1853 23.4717H11.8945V25.4839H14.1853V23.4717Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.33 25.4842C15.8872 25.4842 16.3206 25.0198 16.3206 24.4935C16.3206 23.9363 15.8562 23.5029 15.33 23.5029H14.1846V25.5151H15.33V25.4842Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9115 25.4529C20.4586 25.4529 20.9021 25.0094 20.9021 24.4623C20.9021 23.9152 20.4586 23.4717 19.9115 23.4717C19.3644 23.4717 18.9209 23.9152 18.9209 24.4623C18.9209 25.0094 19.3644 25.4529 19.9115 25.4529Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.014 23.4719C51.4568 23.4719 51.0234 23.9362 51.0234 24.4625C51.0234 25.0197 51.4878 25.4531 52.014 25.4531H53.1594V23.4409H52.014V23.4719Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3046 25.4842C54.8618 25.4842 55.2952 25.0198 55.2952 24.4935C55.2952 23.9363 54.8308 23.5029 54.3046 23.5029H53.1592V25.5151H54.3046V25.4842Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8861 25.4529C59.4332 25.4529 59.8767 25.0094 59.8767 24.4623C59.8767 23.9152 59.4332 23.4717 58.8861 23.4717C58.339 23.4717 57.8955 23.9152 57.8955 24.4623C57.8955 25.0094 58.339 25.4529 58.8861 25.4529Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7592 23.4719C65.2019 23.4719 64.7686 23.9362 64.7686 24.4625C64.7686 25.0197 65.2329 25.4531 65.7592 25.4531H66.9046V23.4409H65.7592V23.4719Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0497 25.4842C68.6069 25.4842 69.0403 25.0198 69.0403 24.4935C69.0403 23.9363 68.576 23.5029 68.0497 23.5029H66.9043V25.5151H68.0497V25.4842Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.16737 27.7439C6.71447 27.7439 7.15798 27.3004 7.15798 26.7533C7.15798 26.2062 6.71447 25.7627 6.16737 25.7627C5.62027 25.7627 5.17676 26.2062 5.17676 26.7533C5.17676 27.3004 5.62027 27.7439 6.16737 27.7439Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0394 25.7629C12.4822 25.7629 12.0488 26.2272 12.0488 26.7535C12.0488 27.2798 12.5132 27.7441 13.0394 27.7441H14.1848V25.7319H13.0394V25.7629Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4754 25.7627H14.1846V27.7749H16.4754V25.7627Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7664 25.7627H16.4756V27.7749H18.7664V25.7627Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0574 25.7627H18.7666V27.7749H21.0574V25.7627Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.203 27.7752C22.7602 27.7752 23.1936 27.3108 23.1936 26.7846C23.1936 26.2583 22.7293 25.7939 22.203 25.7939H21.0576V27.8061H22.203V27.7752Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.723 27.7439C50.2701 27.7439 50.7136 27.3004 50.7136 26.7533C50.7136 26.2062 50.2701 25.7627 49.723 25.7627C49.1759 25.7627 48.7324 26.2062 48.7324 26.7533C48.7324 27.3004 49.1759 27.7439 49.723 27.7439Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4682 27.7439C64.0153 27.7439 64.4588 27.3004 64.4588 26.7533C64.4588 26.2062 64.0153 25.7627 63.4682 25.7627C62.9211 25.7627 62.4775 26.2062 62.4775 26.7533C62.4775 27.3004 62.9211 27.7439 63.4682 27.7439Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0394 28.0532C12.4822 28.0532 12.0488 28.5176 12.0488 29.0438C12.0488 29.5701 12.5132 30.0344 13.0394 30.0344H14.1848V28.0532H13.0394Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.33 30.0657C15.8872 30.0657 16.3206 29.6013 16.3206 29.0751C16.3206 28.5488 15.8562 28.0845 15.33 28.0845H14.1846V30.0967H15.33V30.0657Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9115 30.0344C20.4586 30.0344 20.9021 29.5909 20.9021 29.0438C20.9021 28.4967 20.4586 28.0532 19.9115 28.0532C19.3644 28.0532 18.9209 28.4967 18.9209 29.0438C18.9209 29.5909 19.3644 30.0344 19.9115 30.0344Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.723 30.0344C50.2701 30.0344 50.7136 29.5909 50.7136 29.0438C50.7136 28.4967 50.2701 28.0532 49.723 28.0532C49.1759 28.0532 48.7324 28.4967 48.7324 29.0438C48.7324 29.5909 49.1759 30.0344 49.723 30.0344Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3051 28.0532C53.7478 28.0532 53.3145 28.5176 53.3145 29.0438C53.3145 29.5701 53.7788 30.0344 54.3051 30.0344H55.4505V28.0532H54.3051Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.741 28.0532H55.4502V30.0654H57.741V28.0532Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.032 28.0532H57.7412V30.0654H60.032V28.0532Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.322 28.0532H60.0312V30.0654H62.322V28.0532Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4677 30.0657C64.0249 30.0657 64.4583 29.6013 64.4583 29.0751C64.4583 28.5488 63.9939 28.0845 63.4677 28.0845H62.3223V30.0967H63.4677V30.0657Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.87636 30.3444C3.31914 30.3444 2.88574 30.8088 2.88574 31.335C2.88574 31.8923 3.35009 32.3257 3.87636 32.3257H5.02175V30.3135H3.87636V30.3444Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.16688 32.3562C6.7241 32.3562 7.15749 31.8919 7.15749 31.3656C7.15749 30.8084 6.69314 30.375 6.16688 30.375H5.02148V32.3872H6.16688V32.3562Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3305 30.3444C14.7732 30.3444 14.3398 30.8088 14.3398 31.335C14.3398 31.8923 14.8042 32.3257 15.3305 32.3257H16.4759V30.3135H15.3305V30.3444Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7664 30.3442H16.4756V32.3564H18.7664V30.3442Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.912 32.3562C20.4692 32.3562 20.9026 31.8919 20.9026 31.3656C20.9026 30.8084 20.4383 30.375 19.912 30.375H18.7666V32.3872H19.912V32.3562Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.723 30.3444C49.1658 30.3444 48.7324 30.8088 48.7324 31.335C48.7324 31.8923 49.1968 32.3257 49.723 32.3257H50.8684V30.3135H49.723V30.3444Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0136 32.3562C52.5708 32.3562 53.0042 31.8919 53.0042 31.3656C53.0042 30.8084 52.5398 30.375 52.0136 30.375H50.8682V32.3872H52.0136V32.3562Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8861 32.3255C59.4332 32.3255 59.8767 31.882 59.8767 31.3348C59.8767 30.7877 59.4332 30.3442 58.8861 30.3442C58.339 30.3442 57.8955 30.7877 57.8955 31.3348C57.8955 31.882 58.339 32.3255 58.8861 32.3255Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4682 30.3444C62.9109 30.3444 62.4775 30.8088 62.4775 31.335C62.4775 31.8923 62.9419 32.3257 63.4682 32.3257H64.6135V30.3135H63.4682V30.3444Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7587 32.3562C66.3159 32.3562 66.7493 31.8919 66.7493 31.3656C66.7493 30.8084 66.2849 30.375 65.7587 30.375H64.6133V32.3872H65.7587V32.3562Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.87636 34.6165C4.42346 34.6165 4.86697 34.173 4.86697 33.6259C4.86697 33.0788 4.42346 32.6353 3.87636 32.6353C3.32925 32.6353 2.88574 33.0788 2.88574 33.6259C2.88574 34.173 3.32925 34.6165 3.87636 34.6165Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9115 32.635C19.3543 32.635 18.9209 33.0993 18.9209 33.6256C18.9209 34.1828 19.3852 34.6162 19.9115 34.6162H21.0569V32.604H19.9115V32.635Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.203 34.6472C22.7602 34.6472 23.1936 34.1829 23.1936 33.6566C23.1936 33.0994 22.7293 32.666 22.203 32.666H21.0576V34.6782H22.203V34.6472Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.723 34.6165C50.2701 34.6165 50.7136 34.173 50.7136 33.6259C50.7136 33.0788 50.2701 32.6353 49.723 32.6353C49.1759 32.6353 48.7324 33.0788 48.7324 33.6259C48.7324 34.173 49.1759 34.6165 49.723 34.6165Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3051 34.6165C54.8522 34.6165 55.2957 34.173 55.2957 33.6259C55.2957 33.0788 54.8522 32.6353 54.3051 32.6353C53.758 32.6353 53.3145 33.0788 53.3145 33.6259C53.3145 34.173 53.758 34.6165 54.3051 34.6165Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8861 32.635C58.3289 32.635 57.8955 33.0993 57.8955 33.6256C57.8955 34.1828 58.3599 34.6162 58.8861 34.6162H60.0315V32.604H58.8861V32.635Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1766 34.6472C61.7339 34.6472 62.1673 34.1829 62.1673 33.6566C62.1673 33.0994 61.7029 32.666 61.1766 32.666H60.0312V34.6782H61.1766V34.6472Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0492 34.6165C68.5963 34.6165 69.0398 34.173 69.0398 33.6259C69.0398 33.0788 68.5963 32.6353 68.0492 32.6353C67.5021 32.6353 67.0586 33.0788 67.0586 33.6259C67.0586 34.173 67.5021 34.6165 68.0492 34.6165Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.16737 36.907C6.71447 36.907 7.15798 36.4635 7.15798 35.9164C7.15798 35.3693 6.71447 34.9258 6.16737 34.9258C5.62027 34.9258 5.17676 35.3693 5.17676 35.9164C5.17676 36.4635 5.62027 36.907 6.16737 36.907Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7484 34.9255C10.1912 34.9255 9.75781 35.3898 9.75781 35.9161C9.75781 36.4733 10.2222 36.9067 10.7484 36.9067H11.8938V34.8945H10.7484V34.9255Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0399 36.9378C13.5971 36.9378 14.0305 36.4734 14.0305 35.9472C14.0305 35.3899 13.5662 34.9565 13.0399 34.9565H11.8945V36.9687H13.0399V36.9378Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6215 34.9255C17.0643 34.9255 16.6309 35.3898 16.6309 35.9161C16.6309 36.4733 17.0952 36.9067 17.6215 36.9067H18.7669V34.8945H17.6215V34.9255Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0574 34.9258H18.7666V36.938H21.0574V34.9258Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.203 36.9378C22.7602 36.9378 23.1936 36.4734 23.1936 35.9472C23.1936 35.3899 22.7293 34.9565 22.203 34.9565H21.0576V36.9687H22.203V36.9378Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5951 36.907C57.1422 36.907 57.5857 36.4635 57.5857 35.9164C57.5857 35.3693 57.1422 34.9258 56.5951 34.9258C56.048 34.9258 55.6045 35.3693 55.6045 35.9164C55.6045 36.4635 56.048 36.907 56.5951 36.907Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4682 36.907C64.0153 36.907 64.4588 36.4635 64.4588 35.9164C64.4588 35.3693 64.0153 34.9258 63.4682 34.9258C62.9211 34.9258 62.4775 35.3693 62.4775 35.9164C62.4775 36.4635 62.9211 36.907 63.4682 36.907Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0492 36.907C68.5963 36.907 69.0398 36.4635 69.0398 35.9164C69.0398 35.3693 68.5963 34.9258 68.0492 34.9258C67.5021 34.9258 67.0586 35.3693 67.0586 35.9164C67.0586 36.4635 67.5021 36.907 68.0492 36.907Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.87636 37.2165C3.31914 37.2165 2.88574 37.6809 2.88574 38.2071C2.88574 38.7334 3.35009 39.1977 3.87636 39.1977H5.02175V37.1855H3.87636V37.2165Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.31228 37.2168H5.02148V39.229H7.31228V37.2168Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4579 39.2288C9.01512 39.2288 9.44851 38.7644 9.44851 38.2382C9.44851 37.7119 8.98416 37.2476 8.4579 37.2476H7.3125V39.2597H8.4579V39.2288Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0394 37.2165C12.4822 37.2165 12.0488 37.6809 12.0488 38.2071C12.0488 38.7334 12.5132 39.1977 13.0394 39.1977H14.1848V37.1855H13.0394V37.2165Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.33 39.2288C15.8872 39.2288 16.3206 38.7644 16.3206 38.2382C16.3206 37.7119 15.8562 37.2476 15.33 37.2476H14.1846V39.2597H15.33V39.2288Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9115 39.198C20.4586 39.198 20.9021 38.7545 20.9021 38.2074C20.9021 37.6603 20.4586 37.2168 19.9115 37.2168C19.3644 37.2168 18.9209 37.6603 18.9209 38.2074C18.9209 38.7545 19.3644 39.198 19.9115 39.198Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.014 37.2165C51.4568 37.2165 51.0234 37.6809 51.0234 38.2071C51.0234 38.7334 51.4878 39.1977 52.014 39.1977H53.1594V37.1855H52.014V37.2165Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.45 37.2168H53.1592V39.229H55.45V37.2168Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.741 37.2168H55.4502V39.229H57.741V37.2168Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8866 39.2288C59.4438 39.2288 59.8772 38.7644 59.8772 38.2382C59.8772 37.7119 59.4129 37.2476 58.8866 37.2476H57.7412V39.2597H58.8866V39.2288Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4682 37.2165C62.9109 37.2165 62.4775 37.6809 62.4775 38.2071C62.4775 38.7334 62.9419 39.1977 63.4682 39.1977H64.6135V37.1855H63.4682V37.2165Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9041 37.2168H64.6133V39.229H66.9041V37.2168Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0497 39.2288C68.6069 39.2288 69.0403 38.7644 69.0403 38.2382C69.0403 37.7119 68.576 37.2476 68.0497 37.2476H66.9043V39.2597H68.0497V39.2288Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.87636 39.5073C3.31914 39.5073 2.88574 39.9717 2.88574 40.4979C2.88574 41.0242 3.35009 41.4885 3.87636 41.4885H5.02175V39.5073H3.87636Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.16688 41.5193C6.7241 41.5193 7.15749 41.055 7.15749 40.5287C7.15749 40.0024 6.69314 39.5381 6.16688 39.5381H5.02148V41.5503H6.16688V41.5193Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7484 41.4885C11.2955 41.4885 11.739 41.045 11.739 40.4979C11.739 39.9508 11.2955 39.5073 10.7484 39.5073C10.2013 39.5073 9.75781 39.9508 9.75781 40.4979C9.75781 41.045 10.2013 41.4885 10.7484 41.4885Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3305 39.5073C14.7732 39.5073 14.3398 39.9717 14.3398 40.4979C14.3398 41.0242 14.8042 41.4885 15.3305 41.4885H16.4759V39.5073H15.3305Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7664 39.5073H16.4756V41.5195H18.7664V39.5073Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.912 41.5193C20.4692 41.5193 20.9026 41.055 20.9026 40.5287C20.9026 40.0024 20.4383 39.5381 19.912 39.5381H18.7666V41.5503H19.912V41.5193Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5951 41.4885C57.1422 41.4885 57.5857 41.045 57.5857 40.4979C57.5857 39.9508 57.1422 39.5073 56.5951 39.5073C56.048 39.5073 55.6045 39.9508 55.6045 40.4979C55.6045 41.045 56.048 41.4885 56.5951 41.4885Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.87636 43.7796C4.42346 43.7796 4.86697 43.3361 4.86697 42.789C4.86697 42.2419 4.42346 41.7983 3.87636 41.7983C3.32925 41.7983 2.88574 42.2419 2.88574 42.789C2.88574 43.3361 3.32925 43.7796 3.87636 43.7796Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.45839 43.7796C9.00549 43.7796 9.449 43.3361 9.449 42.789C9.449 42.2419 9.00549 41.7983 8.45839 41.7983C7.91129 41.7983 7.46777 42.2419 7.46777 42.789C7.46777 43.3361 7.91129 43.7796 8.45839 43.7796Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.723 41.798C49.1658 41.798 48.7324 42.2624 48.7324 42.7887C48.7324 43.3149 49.1968 43.7793 49.723 43.7793H50.8684V41.7671H49.723V41.798Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0136 43.8103C52.5708 43.8103 53.0042 43.346 53.0042 42.8197C53.0042 42.2935 52.5398 41.8291 52.0136 41.8291H50.8682V43.8413H52.0136V43.8103Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5951 43.7796C57.1422 43.7796 57.5857 43.3361 57.5857 42.789C57.5857 42.2419 57.1422 41.7983 56.5951 41.7983C56.048 41.7983 55.6045 42.2419 55.6045 42.789C55.6045 43.3361 56.048 43.7796 56.5951 43.7796Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1771 43.7796C61.7242 43.7796 62.1677 43.3361 62.1677 42.789C62.1677 42.2419 61.7242 41.7983 61.1771 41.7983C60.63 41.7983 60.1865 42.2419 60.1865 42.789C60.1865 43.3361 60.63 43.7796 61.1771 43.7796Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7592 43.7796C66.3063 43.7796 66.7498 43.3361 66.7498 42.789C66.7498 42.2419 66.3063 41.7983 65.7592 41.7983C65.2121 41.7983 64.7686 42.2419 64.7686 42.789C64.7686 43.3361 65.2121 43.7796 65.7592 43.7796Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.87636 46.1013C4.42346 46.1013 4.86697 45.6578 4.86697 45.1107C4.86697 44.5636 4.42346 44.1201 3.87636 44.1201C3.32925 44.1201 2.88574 44.5636 2.88574 45.1107C2.88574 45.6578 3.32925 46.1013 3.87636 46.1013Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7484 44.0891C10.1912 44.0891 9.75781 44.5534 9.75781 45.0797C9.75781 45.6059 10.2222 46.0703 10.7484 46.0703H11.8938V44.0581H10.7484V44.0891Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0399 46.1013C13.5971 46.1013 14.0305 45.637 14.0305 45.1107C14.0305 44.5845 13.5662 44.1201 13.0399 44.1201H11.8945V46.1323H13.0399V46.1013Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6215 44.0891C17.0643 44.0891 16.6309 44.5534 16.6309 45.0797C16.6309 45.6059 17.0952 46.0703 17.6215 46.0703H18.7669V44.0581H17.6215V44.0891Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0574 44.0889H18.7666V46.101H21.0574V44.0889Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.203 46.1013C22.7602 46.1013 23.1936 45.637 23.1936 45.1107C23.1936 44.5845 22.7293 44.1201 22.203 44.1201H21.0576V46.1323H22.203V46.1013Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.014 46.1013C52.5611 46.1013 53.0047 45.6578 53.0047 45.1107C53.0047 44.5636 52.5611 44.1201 52.014 44.1201C51.4669 44.1201 51.0234 44.5636 51.0234 45.1107C51.0234 45.6578 51.4669 46.1013 52.014 46.1013Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4682 46.1013C64.0153 46.1013 64.4588 45.6578 64.4588 45.1107C64.4588 44.5636 64.0153 44.1201 63.4682 44.1201C62.9211 44.1201 62.4775 44.5636 62.4775 45.1107C62.4775 45.6578 62.9211 46.1013 63.4682 46.1013Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.87636 48.3919C4.42346 48.3919 4.86697 47.9484 4.86697 47.4013C4.86697 46.8542 4.42346 46.4106 3.87636 46.4106C3.32925 46.4106 2.88574 46.8542 2.88574 47.4013C2.88574 47.9484 3.32925 48.3919 3.87636 48.3919Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.45839 46.3801C7.90117 46.3801 7.46777 46.8444 7.46777 47.3707C7.46777 47.9279 7.93212 48.3613 8.45839 48.3613H9.60378V46.3491H8.45839V46.3801Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7489 48.3919C11.3061 48.3919 11.7395 47.9275 11.7395 47.4013C11.7395 46.844 11.2752 46.4106 10.7489 46.4106H9.60352V48.4228H10.7489V48.3919Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3305 48.3919C15.8776 48.3919 16.3211 47.9484 16.3211 47.4013C16.3211 46.8542 15.8776 46.4106 15.3305 46.4106C14.7834 46.4106 14.3398 46.8542 14.3398 47.4013C14.3398 47.9484 14.7834 48.3919 15.3305 48.3919Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.723 48.3919C50.2701 48.3919 50.7136 47.9484 50.7136 47.4013C50.7136 46.8542 50.2701 46.4106 49.723 46.4106C49.1759 46.4106 48.7324 46.8542 48.7324 47.4013C48.7324 47.9484 49.1759 48.3919 49.723 48.3919Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3051 48.3919C54.8522 48.3919 55.2957 47.9484 55.2957 47.4013C55.2957 46.8542 54.8522 46.4106 54.3051 46.4106C53.758 46.4106 53.3145 46.8542 53.3145 47.4013C53.3145 47.9484 53.758 48.3919 54.3051 48.3919Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8861 46.3801C58.3289 46.3801 57.8955 46.8444 57.8955 47.3707C57.8955 47.9279 58.3599 48.3613 58.8861 48.3613H60.0315V46.3491H58.8861V46.3801Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1766 48.3919C61.7339 48.3919 62.1673 47.9275 62.1673 47.4013C62.1673 46.844 61.7029 46.4106 61.1766 46.4106H60.0312V48.4228H61.1766V48.3919Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7592 46.3801C65.2019 46.3801 64.7686 46.8444 64.7686 47.3707C64.7686 47.9279 65.2329 48.3613 65.7592 48.3613H66.9046V46.3491H65.7592V46.3801Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0497 48.3919C68.6069 48.3919 69.0403 47.9275 69.0403 47.4013C69.0403 46.844 68.576 46.4106 68.0497 46.4106H66.9043V48.4228H68.0497V48.3919Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.87636 50.6829C4.42346 50.6829 4.86697 50.2394 4.86697 49.6923C4.86697 49.1452 4.42346 48.7017 3.87636 48.7017C3.32925 48.7017 2.88574 49.1452 2.88574 49.6923C2.88574 50.2394 3.32925 50.6829 3.87636 50.6829Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7484 50.6829C11.2955 50.6829 11.739 50.2394 11.739 49.6923C11.739 49.1452 11.2955 48.7017 10.7484 48.7017C10.2013 48.7017 9.75781 49.1452 9.75781 49.6923C9.75781 50.2394 10.2013 50.6829 10.7484 50.6829Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6215 50.6829C18.1686 50.6829 18.6121 50.2394 18.6121 49.6923C18.6121 49.1452 18.1686 48.7017 17.6215 48.7017C17.0744 48.7017 16.6309 49.1452 16.6309 49.6923C16.6309 50.2394 17.0744 50.6829 17.6215 50.6829Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0746 48.6706C28.5174 48.6706 28.084 49.135 28.084 49.6612C28.084 50.1875 28.5483 50.6518 29.0746 50.6518H30.22V48.6396H29.0746V48.6706Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5115 48.6704H30.2207V50.6826H32.5115V48.6704Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6571 50.6829C34.2143 50.6829 34.6477 50.2185 34.6477 49.6923C34.6477 49.166 34.1834 48.7017 33.6571 48.7017H32.5117V50.7138H33.6571V50.6829Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2387 50.6829C38.7858 50.6829 39.2293 50.2394 39.2293 49.6923C39.2293 49.1452 38.7858 48.7017 38.2387 48.7017C37.6916 48.7017 37.248 49.1452 37.248 49.6923C37.248 50.2394 37.6916 50.6829 38.2387 50.6829Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.142 50.6829C45.6891 50.6829 46.1326 50.2394 46.1326 49.6923C46.1326 49.1452 45.6891 48.7017 45.142 48.7017C44.5949 48.7017 44.1514 49.1452 44.1514 49.6923C44.1514 50.2394 44.5949 50.6829 45.142 50.6829Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.723 48.6706C49.1658 48.6706 48.7324 49.135 48.7324 49.6612C48.7324 50.1875 49.1968 50.6518 49.723 50.6518H50.8684V48.6396H49.723V48.6706Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.159 48.6704H50.8682V50.6826H53.159V48.6704Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.45 48.6704H53.1592V50.6826H55.45V48.6704Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.741 48.6704H55.4502V50.6826H57.741V48.6704Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8866 50.6829C59.4438 50.6829 59.8772 50.2185 59.8772 49.6923C59.8772 49.166 59.4129 48.7017 58.8866 48.7017H57.7412V50.7138H58.8866V50.6829Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7592 48.6706C65.2019 48.6706 64.7686 49.135 64.7686 49.6612C64.7686 50.1875 65.2329 50.6518 65.7592 50.6518H66.9046V48.6396H65.7592V48.6706Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0497 50.6829C68.6069 50.6829 69.0403 50.2185 69.0403 49.6923C69.0403 49.166 68.576 48.7017 68.0497 48.7017H66.9043V50.7138H68.0497V50.6829Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2025 50.9614C21.6453 50.9614 21.2119 51.4258 21.2119 51.952C21.2119 52.4783 21.6763 52.9426 22.2025 52.9426H23.3479V50.9614H22.2025Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4931 52.9734C25.0503 52.9734 25.4837 52.5091 25.4837 51.9828C25.4837 51.4565 25.0193 50.9922 24.4931 50.9922H23.3477V53.0044H24.4931V52.9734Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3656 52.9734C31.9127 52.9734 32.3562 52.5299 32.3562 51.9828C32.3562 51.4357 31.9127 50.9922 31.3656 50.9922C30.8185 50.9922 30.375 51.4357 30.375 51.9828C30.375 52.5299 30.8185 52.9734 31.3656 52.9734Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9476 50.9614C35.3904 50.9614 34.957 51.4258 34.957 51.952C34.957 52.4783 35.4214 52.9426 35.9476 52.9426H37.093V50.9614H35.9476Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3836 50.9614H37.0928V52.9736H39.3836V50.9614Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6746 50.9614H39.3838V52.9736H41.6746V50.9614Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9656 50.9614H41.6748V52.9736H43.9656V50.9614Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2869 50.9614H43.9961V52.9736H46.2869V50.9614Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5779 50.9614H46.2871V52.9736H48.5779V50.9614Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7235 52.9734C50.2807 52.9734 50.7141 52.5091 50.7141 51.9828C50.7141 51.4565 50.2498 50.9922 49.7235 50.9922H48.5781V53.0044H49.7235V52.9734Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8861 50.9614C58.3289 50.9614 57.8955 51.4258 57.8955 51.952C57.8955 52.4783 58.3599 52.9426 58.8861 52.9426H60.0315V50.9614H58.8861Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1766 52.9734C61.7339 52.9734 62.1673 52.5091 62.1673 51.9828C62.1673 51.4565 61.7029 50.9922 61.1766 50.9922H60.0312V53.0044H61.1766V52.9734Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0492 52.9734C68.5963 52.9734 69.0398 52.5299 69.0398 51.9828C69.0398 51.4357 68.5963 50.9922 68.0492 50.9922C67.5021 50.9922 67.0586 51.4357 67.0586 51.9828C67.0586 52.5299 67.5021 52.9734 68.0492 52.9734Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4935 55.2644C25.0406 55.2644 25.4842 54.8209 25.4842 54.2738C25.4842 53.7267 25.0406 53.2832 24.4935 53.2832C23.9464 53.2832 23.5029 53.7267 23.5029 54.2738C23.5029 54.8209 23.9464 55.2644 24.4935 55.2644Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6566 55.2644C34.2037 55.2644 34.6472 54.8209 34.6472 54.2738C34.6472 53.7267 34.2037 53.2832 33.6566 53.2832C33.1095 53.2832 32.666 53.7267 32.666 54.2738C32.666 54.8209 33.1095 55.2644 33.6566 55.2644Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8197 55.2644C43.3668 55.2644 43.8103 54.8209 43.8103 54.2738C43.8103 53.7267 43.3668 53.2832 42.8197 53.2832C42.2726 53.2832 41.8291 53.7267 41.8291 54.2738C41.8291 54.8209 42.2726 55.2644 42.8197 55.2644Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.432 53.2521C46.8748 53.2521 46.4414 53.7165 46.4414 54.2428C46.4414 54.769 46.9058 55.2334 47.432 55.2334H48.5774V53.2212H47.432V53.2521Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7235 55.2644C50.2807 55.2644 50.7141 54.8001 50.7141 54.2738C50.7141 53.7476 50.2498 53.2832 49.7235 53.2832H48.5781V55.2954H49.7235V55.2644Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3051 55.2644C54.8522 55.2644 55.2957 54.8209 55.2957 54.2738C55.2957 53.7267 54.8522 53.2832 54.3051 53.2832C53.758 53.2832 53.3145 53.7267 53.3145 54.2738C53.3145 54.8209 53.758 55.2644 54.3051 55.2644Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8861 53.2521C58.3289 53.2521 57.8955 53.7165 57.8955 54.2428C57.8955 54.769 58.3599 55.2334 58.8861 55.2334H60.0315V53.2212H58.8861V53.2521Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.322 53.252H60.0312V55.2641H62.322V53.252Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6131 53.252H62.3223V55.2641H64.6131V53.252Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7587 55.2644C66.3159 55.2644 66.7493 54.8001 66.7493 54.2738C66.7493 53.7476 66.2849 53.2832 65.7587 53.2832H64.6133V55.2954H65.7587V55.2644Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9476 57.555C36.4947 57.555 36.9383 57.1114 36.9383 56.5643C36.9383 56.0172 36.4947 55.5737 35.9476 55.5737C35.4005 55.5737 34.957 56.0172 34.957 56.5643C34.957 57.1114 35.4005 57.555 35.9476 57.555Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8197 57.555C43.3668 57.555 43.8103 57.1114 43.8103 56.5643C43.8103 56.0172 43.3668 55.5737 42.8197 55.5737C42.2726 55.5737 41.8291 56.0172 41.8291 56.5643C41.8291 57.1114 42.2726 57.555 42.8197 57.555Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.432 55.5427C46.8748 55.5427 46.4414 56.007 46.4414 56.5333C46.4414 57.0596 46.9058 57.5239 47.432 57.5239H48.5774V55.5117H47.432V55.5427Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7235 57.555C50.2807 57.555 50.7141 57.0906 50.7141 56.5643C50.7141 56.0381 50.2498 55.5737 49.7235 55.5737H48.5781V57.5859H49.7235V57.555Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8861 55.5427C58.3289 55.5427 57.8955 56.007 57.8955 56.5333C57.8955 57.0596 58.3599 57.5239 58.8861 57.5239H60.0315V55.5117H58.8861V55.5427Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1766 57.555C61.7339 57.555 62.1673 57.0906 62.1673 56.5643C62.1673 56.0381 61.7029 55.5737 61.1766 55.5737H60.0312V57.5859H61.1766V57.555Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7592 55.5427C65.2019 55.5427 64.7686 56.007 64.7686 56.5333C64.7686 57.0596 65.2329 57.5239 65.7592 57.5239H66.9046V55.5117H65.7592V55.5427Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0497 57.555C68.6069 57.555 69.0403 57.0906 69.0403 56.5643C69.0403 56.0381 68.576 55.5737 68.0497 55.5737H66.9043V57.5859H68.0497V57.555Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2025 59.846C22.7496 59.846 23.1931 59.4025 23.1931 58.8554C23.1931 58.3083 22.7496 57.8647 22.2025 57.8647C21.6554 57.8647 21.2119 58.3083 21.2119 58.8554C21.2119 59.4025 21.6554 59.846 22.2025 59.846Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0746 59.846C29.6217 59.846 30.0652 59.4025 30.0652 58.8554C30.0652 58.3083 29.6217 57.8647 29.0746 57.8647C28.5275 57.8647 28.084 58.3083 28.084 58.8554C28.084 59.4025 28.5275 59.846 29.0746 59.846Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6566 59.846C34.2037 59.846 34.6472 59.4025 34.6472 58.8554C34.6472 58.3083 34.2037 57.8647 33.6566 57.8647C33.1095 57.8647 32.666 58.3083 32.666 58.8554C32.666 59.4025 33.1095 59.846 33.6566 59.846Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2387 57.8337C37.6814 57.8337 37.248 58.298 37.248 58.8243C37.248 59.3815 37.7124 59.8149 38.2387 59.8149H39.3841V57.8027H38.2387V57.8337Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5292 59.846C41.0864 59.846 41.5198 59.3816 41.5198 58.8554C41.5198 58.2981 41.0554 57.8647 40.5292 57.8647H39.3838V59.8769H40.5292V59.846Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.432 57.8337C46.8748 57.8337 46.4414 58.298 46.4414 58.8243C46.4414 59.3815 46.9058 59.8149 47.432 59.8149H48.5774V57.8027H47.432V57.8337Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8689 57.834H48.5781V59.8462H50.8689V57.834Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.159 57.834H50.8682V59.8462H53.159V57.834Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.45 57.834H53.1592V59.8462H55.45V57.834Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.741 57.834H55.4502V59.8462H57.741V57.834Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8866 59.846C59.4438 59.846 59.8772 59.3816 59.8772 58.8554C59.8772 58.2981 59.4129 57.8647 58.8866 57.8647H57.7412V59.8769H58.8866V59.846Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2025 60.1242C21.6453 60.1242 21.2119 60.5886 21.2119 61.1148C21.2119 61.6721 21.6763 62.1054 22.2025 62.1054H23.3479V60.0933H22.2025V60.1242Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4931 62.1365C25.0503 62.1365 25.4837 61.6721 25.4837 61.1459C25.4837 60.5887 25.0193 60.1553 24.4931 60.1553H23.3477V62.1675H24.4931V62.1365Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0746 60.1242C28.5174 60.1242 28.084 60.5886 28.084 61.1148C28.084 61.6721 28.5483 62.1054 29.0746 62.1054H30.22V60.0933H29.0746V60.1242Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5115 60.1245H30.2207V62.1367H32.5115V60.1245Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6571 62.1365C34.2143 62.1365 34.6477 61.6721 34.6477 61.1459C34.6477 60.5887 34.1834 60.1553 33.6571 60.1553H32.5117V62.1675H33.6571V62.1365Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8197 60.1242C42.2625 60.1242 41.8291 60.5886 41.8291 61.1148C41.8291 61.6721 42.2935 62.1054 42.8197 62.1054H43.9651V60.0933H42.8197V60.1242Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1415 62.1365C45.6987 62.1365 46.1321 61.6721 46.1321 61.1459C46.1321 60.5887 45.6678 60.1553 45.1415 60.1553H43.9961V62.1675H45.1415V62.1365Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.723 60.1242C49.1658 60.1242 48.7324 60.5886 48.7324 61.1148C48.7324 61.6721 49.1968 62.1054 49.723 62.1054H50.8684V60.0933H49.723V60.1242Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.159 60.1245H50.8682V62.1367H53.159V60.1245Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3046 62.1365C54.8618 62.1365 55.2952 61.6721 55.2952 61.1459C55.2952 60.5887 54.8308 60.1553 54.3046 60.1553H53.1592V62.1675H54.3046V62.1365Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8861 60.1242C58.3289 60.1242 57.8955 60.5886 57.8955 61.1148C57.8955 61.6721 58.3599 62.1054 58.8861 62.1054H60.0315V60.0933H58.8861V60.1242Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1766 62.1365C61.7339 62.1365 62.1673 61.6721 62.1673 61.1459C62.1673 60.5887 61.7029 60.1553 61.1766 60.1553H60.0312V62.1675H61.1766V62.1365Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2025 62.4155C21.6453 62.4155 21.2119 62.8799 21.2119 63.4061C21.2119 63.9324 21.6763 64.3968 22.2025 64.3968H23.3479V62.4155H22.2025Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4931 64.4275C25.0503 64.4275 25.4837 63.9632 25.4837 63.4369C25.4837 62.9106 25.0193 62.4463 24.4931 62.4463H23.3477V64.4585H24.4931V64.4275Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6566 62.4155C33.0994 62.4155 32.666 62.8799 32.666 63.4061C32.666 63.9324 33.1304 64.3968 33.6566 64.3968H34.802V62.4155H33.6566Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9472 64.4275C36.5044 64.4275 36.9378 63.9632 36.9378 63.4369C36.9378 62.9106 36.4734 62.4463 35.9472 62.4463H34.8018V64.4585H35.9472V64.4275Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5287 62.4155C39.9715 62.4155 39.5381 62.8799 39.5381 63.4061C39.5381 63.9324 40.0024 64.3968 40.5287 64.3968H41.6741V62.4155H40.5287Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9656 62.4155H41.6748V64.4277H43.9656V62.4155Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1415 64.4275C45.6987 64.4275 46.1321 63.9632 46.1321 63.4369C46.1321 62.9106 45.6678 62.4463 45.1415 62.4463H43.9961V64.4585H45.1415V64.4275Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.014 62.4155C51.4568 62.4155 51.0234 62.8799 51.0234 63.4061C51.0234 63.9324 51.4878 64.3968 52.014 64.3968H53.1594V62.4155H52.014Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.45 62.4155H53.1592V64.4277H55.45V62.4155Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.741 62.4155H55.4502V64.4277H57.741V62.4155Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8866 64.4275C59.4438 64.4275 59.8772 63.9632 59.8772 63.4369C59.8772 62.9106 59.4129 62.4463 58.8866 62.4463H57.7412V64.4585H58.8866V64.4275Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4682 62.4155C62.9109 62.4155 62.4775 62.8799 62.4775 63.4061C62.4775 63.9324 62.9419 64.3968 63.4682 64.3968H64.6135V62.4155H63.4682Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7587 64.4275C66.3159 64.4275 66.7493 63.9632 66.7493 63.4369C66.7493 62.9106 66.2849 62.4463 65.7587 62.4463H64.6133V64.4585H65.7587V64.4275Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4935 66.7185C25.0406 66.7185 25.4842 66.275 25.4842 65.7279C25.4842 65.1808 25.0406 64.7373 24.4935 64.7373C23.9464 64.7373 23.5029 65.1808 23.5029 65.7279C23.5029 66.275 23.9464 66.7185 24.4935 66.7185Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9476 66.7185C36.4947 66.7185 36.9383 66.275 36.9383 65.7279C36.9383 65.1808 36.4947 64.7373 35.9476 64.7373C35.4005 64.7373 34.957 65.1808 34.957 65.7279C34.957 66.275 35.4005 66.7185 35.9476 66.7185Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8197 64.737C42.2625 64.737 41.8291 65.2014 41.8291 65.7276C41.8291 66.2539 42.2935 66.7182 42.8197 66.7182H43.9651V64.7061H42.8197V64.737Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1415 66.7185C45.6987 66.7185 46.1321 66.2542 46.1321 65.7279C46.1321 65.2017 45.6678 64.7373 45.1415 64.7373H43.9961V66.7495H45.1415V66.7185Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5951 66.7185C57.1422 66.7185 57.5857 66.275 57.5857 65.7279C57.5857 65.1808 57.1422 64.7373 56.5951 64.7373C56.048 64.7373 55.6045 65.1808 55.6045 65.7279C55.6045 66.275 56.048 66.7185 56.5951 66.7185Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1771 66.7185C61.7242 66.7185 62.1677 66.275 62.1677 65.7279C62.1677 65.1808 61.7242 64.7373 61.1771 64.7373C60.63 64.7373 60.1865 65.1808 60.1865 65.7279C60.1865 66.275 60.63 66.7185 61.1771 66.7185Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0492 66.7185C68.5963 66.7185 69.0398 66.275 69.0398 65.7279C69.0398 65.1808 68.5963 64.7373 68.0492 64.7373C67.5021 64.7373 67.0586 65.1808 67.0586 65.7279C67.0586 66.275 67.5021 66.7185 68.0492 66.7185Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7846 69.0091C27.3317 69.0091 27.7752 68.5655 27.7752 68.0184C27.7752 67.4713 27.3317 67.0278 26.7846 67.0278C26.2375 67.0278 25.7939 67.4713 25.7939 68.0184C25.7939 68.5655 26.2375 69.0091 26.7846 69.0091Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9476 67.028C35.3904 67.028 34.957 67.4924 34.957 68.0186C34.957 68.5449 35.4214 69.0093 35.9476 69.0093H37.093V66.9971H35.9476V67.028Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2382 69.0091C38.7954 69.0091 39.2288 68.5447 39.2288 68.0184C39.2288 67.4922 38.7644 67.0278 38.2382 67.0278H37.0928V69.04H38.2382V69.0091Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8197 67.028C42.2625 67.028 41.8291 67.4924 41.8291 68.0186C41.8291 68.5449 42.2935 69.0093 42.8197 69.0093H43.9651V66.9971H42.8197V67.028Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2869 67.0278H43.9961V69.04H46.2869V67.0278Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4325 69.0091C47.9897 69.0091 48.4231 68.5447 48.4231 68.0184C48.4231 67.4922 47.9588 67.0278 47.4325 67.0278H46.2871V69.04H47.4325V69.0091Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.014 69.0091C52.5611 69.0091 53.0047 68.5655 53.0047 68.0184C53.0047 67.4713 52.5611 67.0278 52.014 67.0278C51.4669 67.0278 51.0234 67.4713 51.0234 68.0184C51.0234 68.5655 51.4669 69.0091 52.014 69.0091Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5951 67.028C56.0379 67.028 55.6045 67.4924 55.6045 68.0186C55.6045 68.5449 56.0688 69.0093 56.5951 69.0093H57.7405V66.9971H56.5951V67.028Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.032 67.0278H57.7412V69.04H60.032V67.0278Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1766 69.0091C61.7339 69.0091 62.1673 68.5447 62.1673 68.0184C62.1673 67.4922 61.7029 67.0278 61.1766 67.0278H60.0312V69.04H61.1766V69.0091Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.1955 2.7002C2.91689 2.7002 2.7002 2.91689 2.7002 3.1955V4.99099V7.28178V9.57257V11.8634V14.1542V16.4449V18.2404C2.7002 18.519 2.91689 18.7357 3.1955 18.7357H18.2714C18.55 18.7357 18.7667 18.519 18.7667 18.2404V16.4449V14.1542V11.8634V9.57257V7.28178V4.99099V3.1955C18.7667 2.91689 18.55 2.7002 18.2714 2.7002H3.1955ZM16.4759 7.28178V9.57257V11.8634V14.1542V16.1663C16.4759 16.3211 16.3521 16.4449 16.1973 16.4449H5.30055C5.14577 16.4449 5.02194 16.3211 5.02194 16.1663V14.1542V11.8634V9.57257V7.28178V5.2696C5.02194 5.11481 5.14577 4.99099 5.30055 4.99099H16.1973C16.3521 4.99099 16.4759 5.11481 16.4759 5.2696V7.28178Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1849 11.8633V9.57253V7.77704C14.1849 7.49843 13.9682 7.28174 13.6896 7.28174H7.80781C7.5292 7.28174 7.3125 7.49843 7.3125 7.77704V9.57253V11.8633V13.6588C7.3125 13.9374 7.5292 14.1541 7.80781 14.1541H13.7205C13.9991 14.1541 14.2158 13.9374 14.2158 13.6588V11.8633H14.1849Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6232 2.7002C53.3446 2.7002 53.1279 2.91689 53.1279 3.1955V4.99099V7.28178V9.57257V11.8634V14.1542V16.4449V18.2404C53.1279 18.519 53.3446 18.7357 53.6232 18.7357H68.6991C68.9777 18.7357 69.1944 18.519 69.1944 18.2404V16.4449V14.1542V11.8634V9.57257V7.28178V4.99099V3.1955C69.1944 2.91689 68.9777 2.7002 68.6991 2.7002H53.6232ZM66.9036 7.28178V9.57257V11.8634V14.1542V16.1663C66.9036 16.3211 66.7798 16.4449 66.625 16.4449H55.7283C55.5735 16.4449 55.4497 16.3211 55.4497 16.1663V14.1542V11.8634V9.57257V7.28178V5.2696C55.4497 5.11481 55.5735 4.99099 55.7283 4.99099H66.625C66.7798 4.99099 66.9036 5.11481 66.9036 5.2696V7.28178Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6133 11.8633V9.57253V7.77704C64.6133 7.49843 64.3966 7.28174 64.118 7.28174H58.2053C57.9267 7.28174 57.71 7.49843 57.71 7.77704V9.57253V11.8633V13.6588C57.71 13.9374 57.9267 14.1541 58.2053 14.1541H64.118C64.3966 14.1541 64.6133 13.9374 64.6133 13.6588V11.8633Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.1955 53.1284C2.91689 53.1284 2.7002 53.3451 2.7002 53.6237V55.4192V57.71V60.0008V62.2916V64.5824V66.8732V68.6687C2.7002 68.9473 2.91689 69.164 3.1955 69.164H18.2714C18.55 69.164 18.7667 68.9473 18.7667 68.6687V66.8732V64.5824V62.2916V60.0008V57.71V55.4192V53.6237C18.7667 53.3451 18.55 53.1284 18.2714 53.1284C18.2714 53.1284 3.1955 53.1284 3.1955 53.1284ZM16.4759 57.71V60.0008V62.2916V64.5824V66.5946C16.4759 66.7493 16.3521 66.8732 16.1973 66.8732H5.30055C5.14577 66.8732 5.02194 66.7493 5.02194 66.5946V64.5824V62.2916V60.0008V57.71V55.6978C5.02194 55.543 5.14577 55.4192 5.30055 55.4192H16.1973C16.3521 55.4192 16.4759 55.543 16.4759 55.6978V57.71Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1849 62.2915V60.0008V58.2053C14.1849 57.9267 13.9682 57.71 13.6896 57.71H7.80781C7.5292 57.71 7.3125 57.9267 7.3125 58.2053V60.0008V62.2915V64.087C7.3125 64.3656 7.5292 64.5823 7.80781 64.5823H13.7205C13.9991 64.5823 14.2158 64.3656 14.2158 64.087V62.2915H14.1849Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0399 25.4224C30.2201 25.4224 25.5146 30.1278 25.5146 35.9476C25.5146 37.8669 26.0409 39.6624 26.9387 41.2412L33.2229 37.6193C32.9442 37.124 32.7585 36.5668 32.7585 35.9786C32.7585 34.1521 34.2444 32.6972 36.0399 32.6972C37.8664 32.6972 39.3213 34.1831 39.3213 35.9786C39.3213 37.4955 38.2997 38.7956 36.8757 39.1671L38.7641 46.1633C43.2528 44.956 46.5652 40.8697 46.5652 35.9786C46.5652 30.1278 41.8288 25.4224 36.0399 25.4224Z",
    fill: "#ADADAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1924 37.5884L26.9082 41.2103C28.3013 43.594 30.592 45.3895 33.2853 46.1015L35.1736 39.1053C34.3378 38.8886 33.6258 38.3313 33.1924 37.5884Z",
    fill: "#0D0A00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9133_143999"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 4,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnauthQrCode);
export default __webpack_public_path__ + "static/media/unauth-qr-code.520188f0.svg";
export { ForwardRef as ReactComponent };